import { useState, useEffect, useCallback } from "react";
import { FaSearch, FaEdit, FaPlus, FaRegTrashAlt } from 'react-icons/fa';
import SideNave from "../common/sidenav";
import TopNav from "../common/topnav";
import DataTable from 'react-data-table-component';
import '../common/style.css';
import './sarfaesi.css';
import { useNavigate } from 'react-router-dom';
import { viewAccountSubmittedBy, deleteSarfaesiDataByID } from "../http/api"; // Updated import
import Loading from "../loading/loading";
import { useAuth } from "../http/authcontex";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdPayment } from "react-icons/md";

export default function ShowSarfaesi() {
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();
    const authContext = useAuth();
   // const { userRoles } = useAuth();

    const [isSidebarOpen, setIsSidebarOpen] = useState(
        localStorage.getItem('sb|sidebar-toggle') === 'true'
    );

    const [users, setAccountData] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");
    const [filteredUsers, setFilteredUsers] = useState([]);

    // Modal and Delete state
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [accountToDelete, setAccountToDelete] = useState(null);

    // Toast state
    //const [showToast, setShowToast] = useState(false);
    //const [toastMessage, setToastMessage] = useState('');
    //const [toastVariant, setToastVariant] = useState('');


    useEffect(() => {
        localStorage.setItem('sb|sidebar-toggle', isSidebarOpen);
    }, [isSidebarOpen]);

    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
        localStorage.setItem('sb|sidebar-toggle', !isSidebarOpen);
    };

    const viewAccountData = useCallback(() => {
        setLoading(true);
        viewAccountSubmittedBy()
            .then(response => {
                if (response.status === 200) {
                    const accountData = response.data.map(item => ({
                        id: item.id,
                        bankName: item.bank?.bankName || '',
                        branchName: item.bank?.branch?.branchName || '',
                        accountName: item.accountName || '',
                        dateOfAllotment: item.dateOfAllotment || '',
                        npaDate: item.npaDate || '',
                        dateOf132: item.dateOf132 || '',
                        amountDemanded132: item.amountDemanded132 || '',
                        status: item.status || ''
                    }));

                    setAccountData(accountData);
                    setLoading(false);
                }
            })
            .catch(error => {
                setLoading(false);
                if (error.response && error.response.status === 401) {
                    console.error('Unauthorized access, redirecting to login...');
                    authContext.logout();
                    navigate('');
                } else {
                    console.error('Error fetching user details:', error);
                }
            });
    }, [authContext, navigate]);

    useEffect(() => {
        viewAccountData();
    }, [viewAccountData]);

    useEffect(() => {
        const filtered = users.filter(user =>
            Object.values(user).some(value =>
                typeof value === 'string' && value.toLowerCase().includes(searchTerm.toLowerCase())
            )
        );
        setFilteredUsers(filtered);
    }, [searchTerm, users]);

    const handleSearch = (event) => {
        setSearchTerm(event.target.value);
    };

    const handleAdd = () => {
        navigate('/addSarfaesi');
    };

    const handleEdit = (accountDetails) => {
        navigate(`/editSarfaesi`, { state: { accountDetails: accountDetails } });
    };

    const handleDelete = (accountId) => {
        setAccountToDelete(accountId);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = () => {
        if (accountToDelete) {
            deleteSarfaesiDataByID(accountToDelete) // Updated to use deleteSarfaesiDataByID
                .then((response) => {
                    if (response.status === 200 || response.status === 204) {
                        setAccountData(prevUsers => prevUsers.filter(user => user.id !== accountToDelete));
                        setShowDeleteModal(false);
                        toast.success("Account deleted successfully!", {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            style: {
                                border: "3px solid green",
                                borderRadius: "8px",
                                padding: "10px",
                                bottom: "-45px",
                            }
                        });
                    } else {
                        toast.error("Failed to delete account. Please try again.", {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            style: {
                                border: "3px solid red",
                                borderRadius: "8px",
                                padding: "10px",
                                bottom: "-45px",
                            }
                        });
                    }
                })
                .catch((error) => {
                    console.error("Error deleting account:", error);
                    toast.error("Failed to delete account. Please try again.", {
                        position: "top-right",
                        autoClose: 3000,
                        hideProgressBar: true,
                        closeOnClick: true,
                        pauseOnHover: true,
                        draggable: true,
                        progress: undefined,
                        style: {
                            border: "3px solid red",
                            borderRadius: "8px",
                            padding: "10px",
                            bottom: "-45px",
                        }
                    });
                });
        }
    };

    const handleManagePayment = (accountDetails) => {
        navigate("/payment", { state: { accountDetails: accountDetails } });
    };

    const formatDate = (date) => {
        if (!date) return ''; // Return empty string if no date is provided
        const d = new Date(date);
        const day = String(d.getDate()).padStart(2, '0');
        const month = String(d.getMonth() + 1).padStart(2, '0');
        const year = String(d.getFullYear()).slice(-2);
        return `${day}/${month}/${year}`;
    };

    const columns = [
        { name: 'Bank Name', selector: row => row.bankName || '', sortable: true },
        { name: 'Branch Name', selector: row => row.branchName || '', sortable: true },
        { name: 'Account Name', selector: row => row.accountName || '', sortable: true },
        { name: 'Date of allotment', selector: row => formatDate(row.dateOfAllotment), sortable: true },
        { name: 'NPA Date', selector: row => formatDate(row.npaDate), sortable: true },
        { name: 'Date Of 13(2)', selector: row => formatDate(row.dateOf132), sortable: true },
        { name: 'Amount demanded as per 13(2)', selector: row => row.amountDemanded132 || '', sortable: true },
        { name: 'Status', selector: row => row.status || 'New', sortable: true },
        {
            name: 'Actions',
            cell: row => (
                
                    <>
                        <button onClick={() => handleEdit(row)} className="btn btn-sm btn-primary me-1">
                            <FaEdit />
                        </button>

                        <button onClick={() => handleManagePayment(row)} className="btn btn-sm btn-warning me-1">
                            <MdPayment />
                        </button>

                        <button onClick={() => handleDelete(row.id)} className="btn btn-sm btn-danger me-1">
                            <FaRegTrashAlt />
                        </button>



                    </>
              
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true
        },


    ];

    return (
        <div className="ShowUsers">
            {loading && <Loading />}
            <div className={`sb-nav-fixed ${isSidebarOpen ? 'sb-sidenav-toggled' : ''}`}>
                <TopNav toggleSidebar={toggleSidebar} isSidebarOpen={isSidebarOpen} />
                <div id="layoutSidenav">
                    <SideNave isSidebarOpen={isSidebarOpen} />
                    <div id="layoutSidenav_content">
                        <main>
                            <div className="container-fluid px-4">
                                <h4 className="mt-4">Sarfaesi</h4>
                                <hr className="bg-warning" style={{ height: '4px' }} />
                                <div className="mb-3">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <button className="btn btn-sm btn-warning me-2" onClick={handleAdd}>
                                                <FaPlus /> Add Sarfaesi
                                            </button>
                                        </div>
                                        <div className="d-flex align-items-center">
                                            <input
                                                type="text"
                                                placeholder="Search..."
                                                className="form-control me-2"
                                                value={searchTerm}
                                                onChange={handleSearch}
                                            />
                                            <button className="btn btn-sm btn-secondary">
                                                <FaSearch />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                                <div className="card mb-4">
                                    <div className="card-body shadow-sm border-0">
                                        <DataTable
                                            className="data-table"
                                            columns={columns}
                                            data={filteredUsers}
                                            pagination
                                            highlightOnHover
                                        />
                                    </div>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </div>

            {/* Delete Confirmation Modal */}
            {showDeleteModal && (
                <div className="modal fade show" style={{ display: 'block' }} onClick={() => setShowDeleteModal(false)}>
                    <div className="modal-dialog modal-dialog-centered" onClick={(e) => e.stopPropagation()}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Deletion</h5>
                            </div>
                            <div className="modal-body">
                                Are you sure you want to delete this account?
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>
                                    Cancel
                                </button>
                                <button type="button" className="btn btn-danger" onClick={handleDeleteConfirm}>
                                    Delete
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* ToastContainer */}
            <ToastContainer
                position="top-right"
                autoClose={3000}
                hideProgressBar
                newestOnTop
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}
